import { useMutation } from "react-query";
import { createApiWithPath } from "../../client";

export const useUploadVideo = () => {
  return useMutation(
    async ({ fieldTypeId, file }: { fieldTypeId: string; file: File }) => {
      const formData = new FormData();
      formData.append("file", file);
      const crmApi = createApiWithPath("crm");
      const response = await crmApi.post(
        `/field-values/${fieldTypeId}/upload`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      return response.data.data;
    },
  );
};
